/* eslint-disable react/require-default-props */
import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import useModal from './useModal';
// eslint-disable-next-line import/no-cycle
import Modal from './modal';

export const ModalContext = createContext();

const { Provider } = ModalContext;

const ModalProviderMonorepo = ({
  children,
  isMobile,
  width,
  height,
  openFrom,
  escClose = true,
  scrollFix = true,
  padding,
  noBackgroundOpacity = false,
  modalId = 'modal-mount',
  animation = { position: '100%' },
  backgroundClose = false,
  darkClose = false,
  buttonClose = true,
  paddingBackground
}) => {
  const noBackgroundOpacityValue = noBackgroundOpacity ? 'inherit' : false;

  const {
    closeModal,
    openModal,
    modalContent,
    setModal,
    isOpen,
    modalSettings,
    modal,
    handleModal,
    isModalOpen,
    onClose
  } = useModal(isMobile);

  return (
    <Provider
      value={{
        closeModal,
        openModal,
        modalContent,
        setModal,
        isOpen,
        modalSettings,
        modal,
        handleModal,
        isModalOpen,
        onClose,
        modalId,
        isMobile,
        noBackgroundOpacity: noBackgroundOpacityValue,
        width,
        height,
        padding,
        openFrom,
        scrollFix,
        escClose,
        animation,
        backgroundClose,
        darkClose,
        buttonClose,
        paddingBackground
      }}
    >
      <Modal />
      {children}
    </Provider>
  );
};

ModalProviderMonorepo.propTypes = {
  isMobile: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  padding: PropTypes.string,
  openFrom: PropTypes.string,
  escClose: PropTypes.bool,
  scrollFix: PropTypes.bool,
  modalId: PropTypes.string,
  backgroundClose: PropTypes.bool,
  darkClose: PropTypes.bool,
  buttonClose: PropTypes.bool,
  noBackgroundOpacity: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  animation: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  paddingBackground: PropTypes.string
};

export default ModalProviderMonorepo;
